export default "__VITE_ASSET__DzQSBOJd__"